<template>
    <div class="p-3">
        <el-card header="Entregadores e administradores da Beasy">
            <PersonalTable :loading="loading" :height="450" :showRows="10" :cols="[
                // {label: 'Cod', prop: 'id'},
                // {label: 'cargo', prop: 'role'},
                {label: 'Nome', prop: 'name'},
                {label: 'Bairo', prop: 'location'},
                {label: 'Telefone', prop: 'phone'},
            ]" :data="data" >
                <el-table-column label="Cadastrado por" class-name="auto" :min-width="150">
                    <template #default="data">
                        {{data.row.user.name}}
                    </template>
                </el-table-column>
                <el-table-column label="Cargo" class-name="auto" :min-width="150">
                    <template #default="data">
                        {{data.row.role == 'seller' ? 'Entregador':'Administrador'}}
                    </template>
                </el-table-column>
                <el-table-column label="Cadatrado em" class-name="auto" :min-width="100">
                    <template #default="data">
                        {{new Date(data.row.created_at).toLocaleString()}}
                    </template>
                </el-table-column>
                <el-table-column label="Acções" class-name="auto">
                    <template #default="data">
                        <span class="p-2">
                            <el-button type="primary" tag="router-link" :to="'/users/' + data.row.id" icon="View" title="Ver mais"></el-button>
                        </span>
                    </template>
                </el-table-column>
            </PersonalTable>
        </el-card>
    </div>
</template>

<script lang="ts" setup>
    import PersonalTable from '@/components/PersonalTable.vue'
    import Api from '@/services/api'
    import { onBeforeMount } from 'vue'
    import { ref } from 'vue';
    import { ElMessageBox } from 'element-plus';
    import { useStore } from 'vuex';

    const loading = ref<boolean>(true)
    const data = ref<Array<unknown>>()

    const getSellers = async () => {
        const res = await Api.get('admin/users')
        if (res.status == 200) {
            data.value = res.data.users
        } else {
            ElMessageBox.alert('Ocorreu um erro ao buscar os dados')
        }
    }
    onBeforeMount(async () => {
        await getSellers()
        loading.value = false
    })

    const store = useStore()
    store.watch((s, g) => g.openModal, async (val, oldVal) => {
        if (oldVal == 1) {
            await getSellers()
        }
    })
</script>

<style lang="scss">
    .auto {
        min-width: 100px;
        width: auto !important;
        &>* {
            min-width: 100px;
            width: auto !important;
        }
    }
</style>
